import api from "./api-service";

class RoleService {
   async getRoles(filter) {
    return await api.get("/Role/GetRoles", {
      params: filter,
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
        if (response.data) {
          return response.data;
        }
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  }
}
export default new RoleService();